export default __webpack_public_path__ + "static-json/ne_110m_admin_1_states_provinces-bfe519cb10eb989f84a24fc45f1786b4.json";